import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { mockTickets } from '../data/mockData';

const Column = ({ title, status, tickets }) => (
  <div className="flex flex-col h-[calc(100vh-12rem)]">
    <div className="flex justify-between items-center mb-4 border-b border-[#004B87]/20 pb-2">
      <h3 className="text-sm font-bold uppercase tracking-widest">{title}</h3>
      <span className="text-xs font-mono bg-[#004B87]/10 px-2 py-0.5">{tickets.length}</span>
    </div>
    <div className="flex-1 overflow-y-auto space-y-4 pr-2 blueprint-grid-dense p-2 border border-[#004B87]/10">
      {tickets.map(ticket => (
        <div key={ticket.id} className="tech-panel p-4 cursor-grab active:cursor-grabbing hover:border-[#C1440E] transition-colors">
          <div className="flex justify-between items-start mb-2">
            <span className="text-[10px] font-mono text-[#004B87]/60">{ticket.id}</span>
            {ticket.priority === 'high' && <SafeIcon icon="AlertCircle" className="text-[#C1440E] text-xs" />}
          </div>
          <h4 className="text-sm font-semibold mb-1">{ticket.title}</h4>
          <p className="text-xs text-[#004B87]/70 mb-3">{ticket.property}</p>
          <div className="flex justify-between items-center text-[10px] uppercase tracking-widest">
            <span className="text-[#004B87]/50">{ticket.date}</span>
            <button className="text-[#C1440E] hover:underline">View</button>
          </div>
        </div>
      ))}
      {tickets.length === 0 && (
        <div className="h-full flex items-center justify-center text-xs font-mono text-[#004B87]/40 uppercase">
          No records found
        </div>
      )}
    </div>
  </div>
);

export default function Maintenance() {
  const [tickets] = useState(mockTickets);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-8">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-light uppercase tracking-widest">Maintenance Control</h2>
        </div>
        <div className="flex gap-4">
          <div className="relative">
             <SafeIcon icon="Filter" className="absolute left-3 top-1/2 -translate-y-1/2 text-[#004B87]/50 text-sm" />
             <select className="pl-8 pr-8 py-2 bg-transparent border border-[#004B87]/30 text-xs font-mono uppercase focus:outline-none appearance-none">
               <option>All Properties</option>
               <option>Apex Heights</option>
             </select>
          </div>
          <button className="btn-rust flex items-center gap-2">
            <SafeIcon icon="Plus" /> New Ticket
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Column title="Reported" status="todo" tickets={tickets.filter(t => t.status === 'todo')} />
        <Column title="In Progress" status="in-progress" tickets={tickets.filter(t => t.status === 'in-progress')} />
        <Column title="Resolved" status="done" tickets={tickets.filter(t => t.status === 'done')} />
      </div>
    </motion.div>
  );
}